export default {
    lotteryList : state =>{
        let temList = "";
        return temList;
    }
}